import {Injectable} from '@angular/core';
import {ParentService} from "./ParentService";
import {LibraryFolderEntity} from "../model/LibraryFolderEntity";
import {LibraryEntity} from "../model/LibraryEntity";
import {HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import {JustReferenceDto} from "../dto/JustReferenceDto";
import {catchError} from "rxjs/operators";
import {PermissionEntity} from "../model/PermissionEntity";
import {PermissionRoleEntity} from "../model/PermissionRoleEntity";
import {PermissionIntermediateEntity} from "../model/PermissionIntermediateEntity";
import {RoleCourseDto} from "../dto/RoleCourseDto";

@Injectable()
export class PermissionsService extends ParentService{

  public getPermissions(){
    return this.http.get<PermissionEntity[]>(this.shared.MAGNAMENT_URL+'/getPermissions', this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public getPermissionsRole(){
    return this.http.get<PermissionRoleEntity[]>(this.shared.MAGNAMENT_URL+'/getRolesAdmin', this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public getRoleIntermediate(roleId){
    return this.http.get<PermissionIntermediateEntity[]>(this.shared.MAGNAMENT_URL+'/getRoleIntermediate/'+roleId, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public saveRole(role){
    return this.http.post<PermissionRoleEntity>(this.shared.MAGNAMENT_URL+'/saveRole', role, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public savePermissionIntermediate(roleId, intermediateList){
    return this.http.post<PermissionIntermediateEntity[]>(this.shared.MAGNAMENT_URL+'/saveRoleIntermediate/'+roleId, intermediateList, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public getRolesOfCourse(parentId, parentType){
    return this.http.get<RoleCourseDto[]>(this.shared.MAGNAMENT_URL+'/getRolesOfCourse/'+parentId+'/'+parentType, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public saveStudentRole(parentId, parentType, newRoleId, toChangeStudentRoles){
    return this.http.post<PermissionIntermediateEntity[]>(this.shared.MAGNAMENT_URL+'/saveStudentRole/'+parentId+'/'+parentType+'/'+newRoleId, toChangeStudentRoles, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

}
